import { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  useTheme,
} from '@mui/material';

import ExtensionVideo from '@/assets/videos/extension.mp4';
import { SigninModal } from '../Auth/SigninModal';

export const LandingVideoSection = () => {
  const theme = useTheme();
  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false);

  const features = [
    {
      icon: 'fa-light fa-rocket',
      title: 'Quick Signup',
      description: 'Get started in seconds with our simple setup process',
    },
    {
      icon: 'fa-light fa-shield-check',
      title: 'Transparent & Competitive',
      description: 'Wholesale rates with no obligations or hidden fees',
    },
    {
      icon: 'fa-light fa-chart-line',
      title: 'Real-time Rates',
      description: 'Live mortgage rates updated throughout the day',
    },
  ];

  return (
    <Box
      sx={{
        background: theme.palette.mainColors.background1,
        py: { xs: '60px', md: '80px' },
      }}
    >
      <Container sx={{ maxWidth: '1200px' }}>
        {/* Call to Action Section */}
        <Box sx={{ textAlign: 'center', mb: { xs: '60px', md: '80px' } }}>
          <Typography
            variant="h2"
            sx={{
              color: theme.palette.text.primary,
              fontSize: { xs: '2rem', md: '2.5rem', lg: '3rem' },
              fontWeight: 700,
              mb: 3,
            }}
          >
            Ready to get started?
          </Typography>
          <Typography
            variant="h5"
            sx={{
              color: theme.palette.greyShades.grey1,
              fontSize: { xs: '1rem', md: '1.125rem' },
              maxWidth: '600px',
              mx: 'auto',
              lineHeight: 1.6,
              mb: 4,
            }}
          >
            Join our community of homebuyers and investors who are already
            saving money with Unbeatable Loans.
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 6 }}>
            <Button
              variant="contained"
              size="large"
              onClick={() => setIsSignInModalOpen(true)}
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: '8px',
                fontWeight: 600,
                fontSize: '1.125rem',
              }}
            >
              Get Started Today
            </Button>
          </Box>

          {/* Feature Highlights */}
          <Grid container spacing={4} sx={{ maxWidth: '800px', mx: 'auto' }}>
            {features.map((feature, idx) => (
              <Grid item xs={12} md={4} key={idx}>
                <Box sx={{ textAlign: 'center' }}>
                  <Box sx={{ mb: 2 }}>
                    <i
                      className={feature.icon}
                      style={{
                        fontSize: '2.5rem',
                        color: theme.palette.mainColors.primary,
                      }}
                    />
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      color: theme.palette.text.primary,
                      fontWeight: 600,
                      fontSize: '1.125rem',
                      mb: 1,
                    }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: theme.palette.greyShades.grey1,
                      fontSize: '0.875rem',
                      lineHeight: 1.5,
                    }}
                  >
                    {feature.description}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Video Section */}
        <Box sx={{ textAlign: 'center', mb: { xs: '40px', md: '60px' } }}>
          <Typography
            variant="h3"
            sx={{
              color: theme.palette.text.primary,
              fontSize: { xs: '1.75rem', md: '2.25rem' },
              fontWeight: 700,
              mb: 3,
            }}
          >
            See how it works
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: theme.palette.greyShades.grey1,
              fontSize: { xs: '1rem', md: '1.125rem' },
              maxWidth: '600px',
              mx: 'auto',
              lineHeight: 1.6,
              mb: 4,
            }}
          >
            Watch our Chrome extension in action and see how easy it is to shop
            where you normally shop to add a home to the unbeatable loans
            platform, get approved, and make offers.
          </Typography>
        </Box>

        <Card
          sx={{
            background: theme.palette.mainColors.background,
            border: `1px solid ${theme.palette.greyShades.border1}`,
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: `0 20px 40px ${theme.palette.mainColors.background}`,
          }}
        >
          <CardContent sx={{ p: 0 }}>
            <video
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                borderRadius: '16px',
              }}
              controls
              src={ExtensionVideo}
            />
          </CardContent>
        </Card>
      </Container>

      <SigninModal
        isOpen={isSignInModalOpen}
        onClose={() => setIsSignInModalOpen(false)}
      />
    </Box>
  );
};
